import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { environment } from '@environments/environment';
import { Subscription, filter } from 'rxjs';
import { AuthService } from '@appNeo/neoCore/services/auth/auth.service';
import { UsuarioService } from '@appNeo/neoCore/services/usuario/usuario.service';
import { BarsService } from './shared/services/bars/bars.service';
import { SwUpdate } from '@angular/service-worker';
import { StorageService } from './neo/neoCore/services/storage/storage.service';
import { StorageTipo } from './neo/neoCore/helpers/enums/storage-tipo.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'demo-zeus-backoffice';
  subUsuarioSesion: Subscription;
  subUsuarioPermisosRol: Subscription;
  navigationSubscription: Subscription;

  constructor(
    public routerVisibility: BarsService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private usuarioService: UsuarioService,
    private storage: StorageService,
    private swUpdate: SwUpdate) {
      
      // this.requestNotificationPermission();
      
      // this.navigationSubscription = this.router.events.pipe(
      //   filter(event => event instanceof NavigationStart)
      // ).subscribe((event) => {
      //   if(swUpdate.isEnabled) { 
      //     this.swUpdate.checkForUpdate().then(() => {
      //       /**
      //        * Available deprecated. En nuevas versiones de SWUpdate usar versionUpdates 
      //        * Cuando se actualice serviceWorker revisar https://angular.io/api/service-worker/SwUpdate
      //        *  */ 
      //       this.swUpdate.available.subscribe(event => {
      //         this.swUpdate.activateUpdate().then(() => document.location.reload());
      //       });
      //     });
      //   }
      // });

    if (!this.authService.user$.value) {
      this.storage.clear(StorageTipo.LocalStorage);
      this.router.navigate(['auth/login']);
    }

  }

  requestNotificationPermission() {
    if (Notification.permission !== 'granted') {
      Notification.requestPermission();
    }
  }

  ngOnInit(): void {
    // if (environment.activo_cron_store_auth && environment.activo_store_auth) {
    if (environment.activo_store_auth) {
      this.subUsuarioSesion = this.authService.user$.subscribe( usuario => {
        if (usuario) {
          this.subUsuarioPermisosRol = this.usuarioService.lecturaPermisosRolCron().subscribe(data => {});
       }
    });
    }
  }

  ngOnDestroy(): void {
   if (this.subUsuarioPermisosRol) {
      this.subUsuarioPermisosRol.unsubscribe();
    }

    if (this.subUsuarioSesion) {
      this.subUsuarioSesion.unsubscribe();
    }

    // if(this.navigationSubscription) {
    //   this.navigationSubscription.unsubscribe();
    // }   
  }
}
